import { createContext } from 'react';
import { ProductType } from 'types/Products';
import {
  ActiveFilter,
  FacetOrder,
  SearchDocument,
  SearchRequest,
  SearchResults
} from 'types/Search';
import { SegmentTag } from 'types/global';

interface SearchContextValue {
  request: SearchRequest;
  results: SearchResults;
  updateFilters: (activeFilters: ActiveFilter[]) => void;
  clearAllFilters: () => void;

  isPortal: boolean;
  handleToggleFilter: (filterValue: string, filterCategory: string) => void;
  facetOrder: FacetOrder;
  setFacetOrder: (value: FacetOrder) => void;
  compare: {
    active: boolean;
    list: SearchDocument[];
    limit: number;
  };
  onBookmarkChange: (product: SearchDocument, isBookmarked: boolean) => void;
}
const SearchContext = createContext<SearchContextValue>({
  request: {
    query: '',
    target: ProductType.INGREDIENTS,
    segment: SegmentTag.PERSONALCARE,
    size: 100,
    filters: []
  },
  results: {
    total: 0,
    results: [],
    facets: {}
  },
  updateFilters: () => {},
  clearAllFilters: () => {},
  isPortal: false,
  handleToggleFilter: () => {},
  facetOrder: { value: 'COUNT', label: 'Count' },
  setFacetOrder: () => {},
  compare: {
    active: false,
    list: [],
    limit: 0
  },
  onBookmarkChange: () => {}
});

interface Props {
  children: React.ReactNode;
  contextState: SearchContextValue;
}
const SearchProvider: React.FC<Props> = ({ children, contextState }) => {
  const state = contextState;
  return (
    <SearchContext.Provider value={state}>{children}</SearchContext.Provider>
  );
};

export { SearchContext, SearchProvider };
